var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", width: "750" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      !!_vm.persona
        ? _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "headline ma-0" },
                [
                  _c("v-icon", [_vm._v("person")]),
                  _vm._v(" Ver persona\n      "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "" },
                      on: {
                        click: function($event) {
                          return _vm.close()
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                {
                  staticClass: "contenedor-persona",
                  attrs: { color: "grey lighten-4", elevation: "4" }
                },
                [
                  _c(
                    "v-container",
                    {
                      staticClass: "pa-0",
                      staticStyle: { "min-width": "100%" },
                      attrs: { fluid: "", "grid-list-md": "" }
                    },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md6: "" } },
                            [
                              _c(
                                "v-card-text",
                                { staticClass: "contenedor-foto" },
                                [
                                  _c(
                                    "v-avatar",
                                    {
                                      attrs: {
                                        color: _vm.foto
                                          ? "#FFF"
                                          : "light-blue darken-4",
                                        size: "200"
                                      }
                                    },
                                    [
                                      _vm.foto
                                        ? _c("v-img", {
                                            attrs: {
                                              "aspect-ratio": 16 / 9,
                                              src: _vm.foto,
                                              "max-height": "250",
                                              "max-width": "250%",
                                              "min-height": "200",
                                              "min-width": "200"
                                            },
                                            on: {
                                              error: function($event) {
                                                return _vm.handleImageError()
                                              }
                                            }
                                          })
                                        : _c(
                                            "span",
                                            {
                                              staticClass:
                                                "white--text display-2"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  !!_vm.persona.nombres
                                                    ? _vm.persona.nombres[0]
                                                    : "-"
                                                )
                                              )
                                            ]
                                          )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticStyle: { height: "100%" },
                              attrs: { xs12: "", md6: "" }
                            },
                            [
                              _c(
                                "v-card-text",
                                {
                                  staticClass:
                                    "mt-3 mb-0 pt-0 pb-0 text-xs-center"
                                },
                                [
                                  _c(
                                    "h4",
                                    {
                                      staticClass:
                                        "font-weight-bold blue--text m-0",
                                      staticStyle: { "font-size": "1.5rem" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.persona.ap_paterno) +
                                          " " +
                                          _vm._s(_vm.persona.ap_materno) +
                                          "\n                " +
                                          _vm._s(_vm.persona.nombres) +
                                          "\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "h4",
                                    {
                                      staticClass: "font-weight-light",
                                      staticStyle: { "font-size": "1.1em" }
                                    },
                                    [
                                      _c("b", [_vm._v("C.I.:")]),
                                      _vm._v(
                                        _vm._s(_vm.persona.nro_doc) +
                                          "\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "table",
                                    { staticClass: "table-datos-personales" },
                                    _vm._l(_vm.l_datos_personales, function(
                                      dato
                                    ) {
                                      return _c("tr", { key: dato.key }, [
                                        _c(
                                          "td",
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  dark: "",
                                                  small: "",
                                                  icon: "",
                                                  color: "primary",
                                                  outline: ""
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "material-symbols-outlined"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(dato.icon) +
                                                        "\n                      "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("td", [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "titulo-personal font-weight-bold blue--text"
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(dato.label) +
                                                  "\n                    "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "subtitulo-personal"
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.persona[dato.key]
                                                  ) +
                                                  "\n                    "
                                              )
                                            ]
                                          )
                                        ])
                                      ])
                                    }),
                                    0
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-333b1404", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-333b1404","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/reportes_lista_personal/dialogs/VerDetallePersona.vue
// module id = null
// module chunks = 